import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BasePatternLock } from '../components/base-pattern-lock/Component.js';
import 'classnames';
import '../../../button/esm/mobile';
import '../../../shared/esm';
import '@alfalab/react-canvas-pattern-lock';
import '../consts.js';
import '../utils.js';

var styles = {"component":"pattern-lock__component_aaswz","forgotBtn":"pattern-lock__forgotBtn_aaswz","hiddenBtn":"pattern-lock__hiddenBtn_aaswz"};
require('./desktop.css');

var PatternLockDesktop = forwardRef(function (restProps, ref) { return React.createElement(BasePatternLock, __assign({}, restProps, { hover: true, ref: ref, styles: styles })); });
PatternLockDesktop.displayName = 'PatternLockDesktop';

export { PatternLockDesktop };
